module.exports = __webpack_public_path__ + "static/media/4.359b5407.svg";